import Paper from '@/components/core/paper/Paper';
import checkTemplate from './checkTemplate';
import config from './productType.js';
import uploadPictures from '../../../components/productComponent/newUploadBtn';
import UploadPlayer from '../../../components/productComponent/newUploadPlayer';
import { managementInquiry, managementSave, templateDetails } from '../../../api/product';
export default {
    name: 'producttype',
    data() {
        return {
            rowInf: '',
            checkNames: true,
            saveBlock: false,
            config: config,
            id: '',
            videoName: '',
            videoArr: [],
            pictureArr: [],
            playNumCheck: true,
            pictureCheck: true,
            imgList: [],
            modifyCode: true,
            changeTemplate: false,
            tableData: [],
            rules: {
                productCode: [{ required: true, message: '产品编码不能为空', trigger: 'blur' }],
                productName: [{ required: true, message: '产品名称不能为空', trigger: 'blur' }],
                productTemplateName: [{ required: true, message: '产品模板不能为空', trigger: 'blur' }]
            },
            dialogVisible: false,
            productTemplate: false,
            // 头部筛选内容，跳转链接
            itemList: {
                id: '',
                productCode: '',
                productName: '',
                productTemplateId: '',
                productTemplateCode: '',
                productTemplateName: '',
                status: 'Y',
                jump: 'N',
                version: null,
                link: '',
                productAttributeList: []
            },
            sendArray: []
        };
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },
        checkEng($index, attributeValue) {
            const regs = /^[a-zA-Z]*$/g;
            if (regs.test(attributeValue)) {
                this.itemList.productAttributeList[$index].attributeValue = '';
                this.$message({
                    message: '请输入正确的数字类型（小数点后两位）',
                    type: 'warning'
                });
            }
        },
        checkNumber($index, attributeValue) {
            const reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/g;
            const numberAnswer = reg.test(attributeValue);
            if (numberAnswer) {
            } else {
                this.itemList.productAttributeList[$index].attributeValue = '';
                this.$message({
                    message: '请输入正确的数字类型',
                    type: 'warning'
                });
            }
        },
        channelInputLimit(e) {
            const key = e.key;
            // 不允许输入'e'和'.'
            if (key === '——' || key === '-' || key === 'e' || key === 'E') {
                e.returnValue = false;
                return false;
            }
            return true;
        },
        deleteRow($index, row) {
            this.$confirm('此操作将删除该条模板, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.itemList.productAttributeList.splice($index, 1);
                this.throughArray();
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message('取消删除');
                this.throughArray();
            });
        },
        // 是否跳转链接
        jumpClearCheck(value) {
            this.$nextTick(() => {
                this.$refs.ruleForm.clearValidate();
            });
            if (this.itemList.jump === 'Y') {
                this.itemList.productTemplateName = '';
            }
        },
        // 切割图片
        screenCutPicture(productAttributeList) {
            productAttributeList.map(item => {
                item.showPicture = [];
                if (+item.attributeType === 2) {
                    if (item.attributeValue) {
                        item.showPicture = item.attributeValue;
                        item.showPicture = item.showPicture.split(',');
                        for (var i = 0; i < item.showPicture.length; i++) {
                            if (item.showPicture[i] === 'null') {
                                item.showPicture.splice(i, 1);
                            }
                            if (item.showPicture[i] === '') {
                                item.showPicture.splice(i, 1);
                            }
                        }
                    }
                } else if (+item.attributeType === 3) {
                    if (item.attributeValue) {
                        item.attributeValue = item.attributeValue.split(',')[0];
                        const videoRules = (item.attributeValue).lastIndexOf('\/');
                        (item.attributeValue) = (item.attributeValue).substring(videoRules + 1, (item.attributeValue).length);
                        if (item.attributeValue === 'null') {
                            item.attributeValue = '';
                        }
                    }
                }
            });
        },
        // 获取图片数组，切割
        cutPicture() {
            this.sendArray = JSON.parse(JSON.stringify(this.itemList.productAttributeList));
            let showList = [];
            let imgPath = '';
            for (let i = 0; i < this.sendArray.length; i++) {
                if (this.sendArray[i].attributeType === '2') {
                    showList = this.sendArray[i].showPicture;
                    for (let j = 0; j < showList.length; j++) {
                        const rules = showList[j].lastIndexOf('\/');
                        showList[j] = showList[j].substring(rules + 1, showList[j].length);
                    }
                    for (let z = 0; z < showList.length; z++) {
                        imgPath += showList[z] + ',';
                    }
                    this.sendArray[i].attributeValue = imgPath;
                }
                delete this.sendArray[i].index;
                delete this.sendArray[i].showPicture;
            }
        },
        // 删除图片
        deletePicture(index) {
            this.$confirm('是否该图片, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.itemList.productAttributeList[this.rowInf].showPicture.splice(index, 1);
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消'
                    });
                });
        },
        // 将图片路径存储
        pushImg(row) {
            this.itemList.productAttributeList[this.rowInf].showPicture.push(row);
        },
        // 将视频路径存储
        pushUrl(row) {
            this.itemList.productAttributeList.map(item => {
                if (item.attributeType === '3') {
                    item.attributeValue = row;
                    item.editing = false;
                }
            });
        },
        // 清楚当行视频路径
        clearVideo(row) {
            this.$confirm('是否删除该路径, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    row.attributeValue = '';
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消更改'
                    });
                });
        },
        // 下拉框值变动时触发
        currStationChange(val) {
            val.attributeValue = '';
            this.throughArray();
        },
        // 便利数组
        throughArray() {
            this.itemList.productAttributeList.map(item => {
                if (item.attributeType === '3') {
                    this.videoArr.push(item.attributeType);
                }
                if (item.attributeType === '2') {
                    this.pictureArr.push(item.attributeType);
                }
            });
            if (this.videoArr.length > 1) {
                this.$message({
                    message: '视频属性，只可以添加一条',
                    type: 'warning'
                });
                this.videoArr.length = 0;
                this.playNumCheck = false;
            } else {
                this.playNumCheck = true;
                this.videoArr.length = 0;
            }
            if (this.pictureArr.length > 1) {
                this.$message({
                    message: '图片属性，只可以添加一条',
                    type: 'warning'
                });
                this.pictureArr.length = 0;
                this.pictureCheck = false;
            } else {
                this.pictureCheck = true;
                this.pictureArr.length = 0;
            }
        },
        // 关闭对话框，取消校验规则
        clearCheck() {
            this.productTemplate = false;
            this.$refs.productTemplate.tableData.length = 0;
        },
        // 获取选择的模板
        getTemplate() {
            this.productTemplate = false;
            this.$refs.productTemplate.tableData.length = 0;
            const getTemplate = this.$refs.productTemplate.pushTemplate;
            if (getTemplate.productTemplateId) {
                this.itemList.productTemplateId = getTemplate.productTemplateId;
                this.itemList.productTemplateCode = getTemplate.productTemplateCode;
                this.itemList.productTemplateName = getTemplate.productTemplateName;
                templateDetails({ id: getTemplate.productTemplateId }).then(res => {
                    var arrs = [];
                    this.screenCutPicture(res.data.attributeList);
                    res.data.attributeList.forEach(function(item) {
                        arrs.push({
                            attributeName: item.attributeName,
                            attributeType: (item.attributeType).toString(),
                            attributeValue: item.attributeValue,
                            display: item.display,
                            effect: item.effect,
                            required: item.required,
                            version: item.version,
                            id: item.id,
                            showPicture: item.showPicture
                        });
                    });
                    this.itemList.productAttributeList = arrs;
                });
            } else {
            }
        },
        // 点击打开模板，进行选择
        openTemplate() {
            if (this.changeTemplate === true && this.itemList.jump === 'N') {
                this.productTemplate = true;
            } else if (this.changeTemplate === true && this.itemList.jump === 'Y') {
                this.$message({
                    message: '已勾选跳转链接，不能选择产品模板',
                    type: 'warning'
                });
            } else if (this.changeTemplate === false) {
                this.$message({
                    message: '不能修改产品模板',
                    type: 'warning'
                });
            }
        },
        // 点击当行可修改
        check(row) {
            this.rowInf = row.index;
            this.$set(row, 'editing', true);
        },
        // 新增一条模板数据，当前条数最多为50
        addTemp() {
            this.throughArray();
            if (this.playNumCheck === true && this.pictureCheck === true) {
                if (this.itemList.productAttributeList.length > 51) {
                    this.$message({
                        message: '当前允许，最多50条记录',
                        type: 'warning'
                    });
                } else {
                    this.itemList.productAttributeList = this.itemList.productAttributeList || [];
                    this.itemList.productAttributeList.push({
                        attributeName: '',
                        attributeType: '0',
                        attributeValue: '',
                        display: 'Y',
                        required: 'Y',
                        effect: 'Y',
                        editing: true,
                        editings: true,
                        version: '',
                        id: '',
                        showPicture: []
                    });
                    this.$nextTick(() => {
                        this.$refs.tables.bodyWrapper.scrollTop = this.$refs.tables.bodyWrapper.scrollHeight;
                    });
                }
            } else {
                this.$message({
                    message: '图片/视频属性值只允许添加一条',
                    type: 'warning'
                });
            }
        },
        // 取消-跳转回
        cancel() {
            this.$eventBus.$emit('closeTag', this.$route);
            this.$router.go(-1);
        },
        checkName() {
            this.itemList.productAttributeList.map(item => {
                if (!item.attributeName) {
                    this.checkNames = false;
                }
            });
        },
        // 保存-发送保存请求，并跳转回去
        save() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.saveBlock = true;
                    if (this.itemList.jump === 'Y') {
                        // 跳转链接请求
                        this.itemList.productAttributeList.length = 0;
                        this.itemList.productTemplateCode = '';
                        this.itemList.productTemplateId = '';
                        this.itemList.productTemplateName = '';
                        managementSave(this.itemList).then(res => {
                            if (res.code === '0') {
                                this.$message({
                                    message: '保存成功',
                                    type: 'success'
                                });
                                this.$eventBus.$emit('closeTag', this.$route);
                                this.$router.go(-1);
                            }
                            this.saveBlock = false;
                        }).catch(() => {
                            this.saveBlock = false;
                        });
                    } else {
                        this.checkName();
                        if (this.playNumCheck === true && this.pictureCheck === true && this.checkNames === true) {
                            this.cutPicture();
                            const pushData = {
                                id: this.itemList.id,
                                jump: this.itemList.jump,
                                link: this.itemList.link,
                                productAttributeList: this.sendArray,
                                productCode: this.itemList.productCode,
                                productName: this.itemList.productName,
                                productTemplateCode: this.itemList.productTemplateCode,
                                productTemplateId: this.itemList.productTemplateId,
                                productTemplateName: this.itemList.productTemplateName,
                                status: this.itemList.status,
                                version: this.itemList.version
                            };
                            managementSave(pushData).then(res => {
                                if (res.code === '0') {
                                    this.$message({
                                        message: '保存成功',
                                        type: 'success'
                                    });
                                    this.sendArray.length = 0;
                                    this.$eventBus.$emit('closeTag', this.$route);
                                    this.$router.go(-1);
                                }
                                this.saveBlock = false;
                            }).catch(() => {
                                this.sendArray.length = 0;
                                this.saveBlock = false;
                            });
                        } else if (this.checkNames === false) {
                            this.saveBlock = false;
                            this.$message({
                                message: '属性名称不能为空',
                                type: 'warning'
                            });
                            this.checkNames = true;
                        } else {
                            this.saveBlock = false;
                            this.$message({
                                message: '图片/视频属性值只允许添加一条',
                                type: 'warning'
                            });
                        }
                    }
                } else {
                    return false;
                }
            });
        },
        // 进入页面，获取数据
        getPull(id) {
            managementInquiry({ id: id }).then(res => {
                // 判断是否有跳转链接
                if (res.data.jump === 'Y') {
                    Object.keys(this.itemList).forEach(key => {
                        this.itemList[key] = res.data[key];
                    });
                } else {
                    // 遍历赋值规则编码、模板名称、模板说明、状态
                    Object.keys(this.itemList).forEach(key => {
                        this.itemList[key] = res.data[key];
                    });
                    // 渲染产品属性
                    var arr = [];
                    this.screenCutPicture(res.data.productAttributeList);
                    res.data.productAttributeList.forEach(function(item) {
                        arr.push({
                            attributeName: item.attributeName,
                            attributeType: (item.attributeType).toString(),
                            attributeValue: item.attributeValue,
                            display: item.display,
                            effect: item.effect,
                            required: item.required,
                            version: item.version,
                            id: item.id,
                            showPicture: item.showPicture
                        });
                    });
                    this.itemList.productAttributeList = arr;
                }
            });
        }
    },
    computed: {
        productTemplateNameChange() {
            return this.itemList.jump === 'N' ? 'productTemplateName' : '';
        }
    },
    components: {
        Paper,
        checkTemplate,
        uploadPictures,
        UploadPlayer
    },
    created() {
        if (this.$route.query.id) {
            this.getPull(this.$route.query.id);
            this.id = this.$route.query.id;
            this.changeTemplate = false;
        } else {
            this.changeTemplate = true;
            this.modifyCode = false;
        }
    },
    activated() {
        this.changeTemplate = false;
        if (this.$route.query.id) {
            if (this.id !== this.$route.query.id) {
                this.getPull(this.$route.query.id);
                this.id = this.$route.query.id;
            }
        } else {
            this.changeTemplate = true;
            this.modifyCode = false;
            this.itemList = this.$options.data().itemList;
        }
    },
    deactivated() {
        this.$refs.ruleForm.clearValidate();
        this.modifyCode = true;
    }
};